import Head from 'next/head';

const PublicLayout = ({children}) => {
  return (
    <>
      <Head>
        <meta name="format-detection" content="telephone=no" />
      </Head>
      
      {children}
    </>
  );
};

export const getPublicLayout = (page) => <PublicLayout>{page}</PublicLayout>;
